// Global
import ButtonPrimary from "./Global/ButtonPrimary.vue";
import ButtonCTA from "./Global/ButtonCTA.vue";
import ButtonSecondary from "./Global/ButtonSecondary.vue";
import ButtonTertiary from "./Global/ButtonTertiary.vue";
import ButtonText from "./Global/ButtonText.vue";
import ButtonLike from "./Global/ButtonLike.vue";
import ButtonIcon from "./Global/ButtonIcon.vue";
import ButtonOrderMore from "./Global/ButtonOrderMore.vue";
import ButtonTooltipHayadata from "./Global/ButtonTooltipHayadata.vue";
import ButtonTooltipErrorHayadata from "./Global/ButtonTooltipErrorHayadata.vue";
import ButtonTooltipIconHayadata from "./Global/ButtonTooltipIconHayadata.vue";
import InputAmount from "./Global/InputAmount.vue";
import SelectNumber from "./Global/SelectNumber.vue";
import SelectPayment from "./Global/SelectPayment.vue";
import TooltipHayadata from "./Global/TooltipHayadata.vue";
import TooltipMissingProduct from "./Global/TooltipMissingProduct.vue";
import TooltipCVV from "./Global/TooltipCVV.vue";
import TooltipSmall from "./Global/TooltipSmall.vue";
import IconMishnat from "./Global/IconMishnat.vue";
import InputDefault from "./Global/InputDefault.vue";
import InputPassword from "./Global/InputPassword.vue";
import CategoriesMenu from "./Global/CategoriesMenu.vue";
import CategoriesMenuView from "./Global/CategoriesMenuView.vue";
import RadioSelect from "./Global/RadioSelect.vue";
import CheckBox from "./Global/CheckBox.vue";
import CheckBoxByNumbers from "./Global/CheckBoxByNumbers.vue";
import ErrorBlock from "./Global/ErrorBlock.vue";
import SuccessBlock from "./Global/SuccessBlock.vue";
import Station from "./Global/Station.vue";
import StationAddressForm from "./Global/StationAddressForm.vue";

// SalesBoard
import CardSale from "./SalesBoard/CardSale.vue";
import StripSaleToBeTaken from "./SalesBoard/StripSaleToBeTaken.vue";
import CardComingSale from "./SalesBoard/CardComingSale.vue";
import CardSaleMissing from "./SalesBoard/CardSaleMissing.vue";
import StripSaleToBeTakenMissing from "./SalesBoard/StripSaleToBeTakenMissing.vue";
import LocationSection from "./SalesBoard/LocationSection.vue";
import TitleSection from "./SalesBoard/TitleSection.vue";

// Order imports
import Cart from "./Order/Cart.vue";
import CartProductsList from "./Order/CartProductsList.vue";
import CartProduct from "./Order/CartProduct.vue";
import CartProductShipping from "./Order/CartProductShipping.vue";
import CartProductCollecting from "./Order/CartProductCollecting.vue";
import Product from "./Order/Product.vue";
import ProductsList from "./Order/ProductsList.vue";
import ModalProduct from "./Order/ModalProduct.vue";
import ModalProductTabs from "./Order/ModalProductTabs.vue";
import ModalAgrement from "./Order/ModalAgrement.vue";
import ToastNotifications from "./Order/ToastNotifications.vue";
import VipBannerCollecting from "./Order/VipBannerCollecting.vue";
import VipBannerShipping from "./Order/VipBannerShipping.vue";
import ProductBadge from "./Order/ProductBadge.vue";
import ProductGalleryDescription from "./Order/ProductGalleryDescription.vue";

// Registration
import PasswordChecks from "./Registration/PasswordChecks.vue";
import InputOTP from "./Registration/InputOTP.vue";
import ResendPhoneCode from "./Registration/ResendPhoneCode.vue";
import FindStationStep1 from "./Registration/FindStationStep1.vue";
import FindStationStep2 from "./Registration/FindStationStep2.vue";
import Loader from "./Registration/Loader.vue";
import EmailVerificationUnsuccessful from "./Registration/EmailVerificationUnsuccessful.vue";
import EmailVerificationSuccessful from "./Registration/EmailVerificationSuccessful.vue";
import ResendEmailVerification from "./Registration/ResendEmailVerification.vue";
import ResendPasswordVerification from "./Registration/ResendPasswordVerification.vue";
import CompleteUser from "./Registration/CompleteUser.vue";
import CompleteCard from "./Registration/CompleteCard.vue";

// Profile
import PersonalDetailsCard from "./Profile/PersonalDetailsCard.vue";
import AccountDetailsCard from "./Profile/AccountDetailsCard.vue";
import MyStationCard from "./Profile/MyStationCard.vue";
import ChangeStationModal from "./Profile/ChangeStationModal.vue";
import ManagingRemindersCard from "./Profile/ManagingRemindersCard.vue";
import ManagingRefund from "./Profile/ManagingRefund.vue";
import DropdownReminders from "./Profile/DropdownReminders.vue";
import ChildComponentTest from "./Profile/ChildComponentTest.vue";
import MatatzimCard from "./Profile/MatatzimCard.vue";

// Payment Methods
import AddCreditCard from "./PaymentMethods/AddCreditCard.vue";
import AddPrepaidCard from "./PaymentMethods/AddPrepaidCard.vue";

// FAQ
import FaqDisclosure from "./Faq/FaqDisclosure.vue";
import FaqFact from "./Faq/FaqFact.vue";

// Notifications Modal
import NotificationsModal from "./NotificationsModal/NotificationsModal.vue";

// Onboarding Modal
import OnboardingModal from "./Onboarding/Onboarding.vue";

//Modals
import PayDebtModal from "./Modals/PayDebtModal.vue";
import CompleteRegistrationNowModal from "./Modals/CompleteRegistrationNowModal.vue";

//Calendar
import Calendar from "./Calendar/Calendar.vue";
import ActiveSaleEvent from "./Calendar/ActiveSaleEvent.vue";
import DoneSaleEvent from "./Calendar/DoneSaleEvent.vue";
import ComingSaleEvent from "./Calendar/ComingSaleEvent.vue";

//Complete Registration Modal
import CompleteRegistrationModal from "./CompleteRegistrationModal/CompleteRegistrationModal.vue";

export default [
  // Global exports
  ButtonPrimary,
  ButtonCTA,
  ButtonSecondary,
  ButtonTertiary,
  ButtonText,
  ButtonLike,
  ButtonIcon,
  ButtonOrderMore,
  ButtonTooltipHayadata,
  ButtonTooltipErrorHayadata,
  ButtonTooltipIconHayadata,
  InputAmount,
  SelectNumber,
  SelectPayment,
  TooltipHayadata,
  TooltipMissingProduct,
  TooltipSmall,
  TooltipCVV,
  IconMishnat,
  InputDefault,
  InputPassword,
  CategoriesMenu,
  CategoriesMenuView,
  RadioSelect,
  CheckBox,
  CheckBoxByNumbers,
  ErrorBlock,
  SuccessBlock,

  // SalesBoard exports
  CardSale,
  StripSaleToBeTaken,
  CardComingSale,
  CardSaleMissing,
  StripSaleToBeTakenMissing,
  LocationSection,
  TitleSection,

  // Order exports
  Cart,
  CartProductsList,
  CartProduct,
  CartProductShipping,
  CartProductCollecting,
  Product,
  ProductsList,
  ModalProduct,
  ModalProductTabs,
  ModalAgrement,
  ToastNotifications,
  VipBannerCollecting,
  VipBannerShipping,
  ProductBadge,
  ProductGalleryDescription,

  // Registration exports
  PasswordChecks,
  Station,
  InputOTP,
  ResendPhoneCode,
  Loader,
  EmailVerificationUnsuccessful,
  EmailVerificationSuccessful,
  ResendEmailVerification,
  ResendPasswordVerification,
  CompleteUser,
  CompleteCard,

  //Find Station
  StationAddressForm,
  FindStationStep1,
  FindStationStep2,

  // Profile
  PersonalDetailsCard,
  AccountDetailsCard,
  MyStationCard,
  ChangeStationModal,
  ManagingRemindersCard,
  ManagingRefund,
  DropdownReminders,
  ChildComponentTest,
  MatatzimCard,

  // Payment Methods
  AddCreditCard,
  AddPrepaidCard,

  // FAQ
  FaqDisclosure,
  FaqFact,

  // Messages Modal
  NotificationsModal,

  // Messages Modal
  OnboardingModal,

  //Modals
  PayDebtModal,
  CompleteRegistrationNowModal,

  //Calendar
  Calendar,
  ActiveSaleEvent,
  DoneSaleEvent,
  ComingSaleEvent,

  //Complete Registration Modal
  CompleteRegistrationModal,
];
